import React from 'react';
import { View, Text } from '@smarterservices/smarter-ui';

/**
 * ElementNotFound component
 * Displayed when an element route is not found
 */
const ElementNotFound = () => {
  return (
    <View as="div" textAlign="center" padding="medium" background="primary">
      <Text color="danger" size="large">
        Element Not Found
      </Text>
      <Text as="div" margin="small 0 0 0">
        The requested element could not be found. Please check the URL and try again.
      </Text>
    </View>
  );
};

export default ElementNotFound;
